import axios from "axios";
import { urlApi } from "@/global";

let cache = null;

export async function fetchManualContent() {
  if (cache) return cache;
  try {
    const res = await axios.get(`${urlApi}/analytics/ai/manual`);
    cache = res.data;
    return cache;
  } catch (err) {
    console.error("Erro ao buscar manual do backend", err);
    return "";
  }
}

export default null;
